import apiService from "./apiService";
import cacheService from "./cacheService";

// Cache keys
const CACHE_KEYS = {
  BONDED_CASHIERS: 'bonded-cashiers'
};

const umService = {
  async getBondedCashiers(forceRefresh = false) {
    try {
      // Return cached data if exists and not forcing refresh
      if (!forceRefresh) {
        const cached = cacheService.get(CACHE_KEYS.BONDED_CASHIERS);
        if (cached) return cached;
      }

      // Fetch fresh data
      const data = (await apiService.get(`um/get-bonded-cashiers`, {}, true)).data;
      
      // Cache the response
      cacheService.set(CACHE_KEYS.BONDED_CASHIERS, data);
      return data;
    } catch {
      // Return empty array on error (consider returning cached data here if available)
      return [];
    }
  },

  // Clear all cache or specific cache
  clearCache(key = null) {
    if (key) {
      cacheService.delete(key);
    } else {
      cacheService.clear();
    }
  },
 async saveConcessionaire(concessionaire){
    try{
        return (await apiService.post(`um/save-concessionaire`, concessionaire, true)).data;
    }
    catch(e){
       return {success: false, message: e}
    }
 },
};

export default umService;